import type {SVGProps} from 'react';
import './bite-credit.css';

export function BiteCreditIcon({className='',...props}:SVGProps<SVGSVGElement>) {
  return <svg {...props} className={`bite-credit-icon ${className}`} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path fill="currentColor" fillRule="evenodd" d="M10 1.65a4 4 0 0 1 4 0l6.1 3.52a4 4 0 0 1 2 3.47v6.72a4 4 0 0 1-2 3.47L14 22.35a4 4 0 0 1-4 0l-6.1-3.52a4 4 0 0 1-2-3.47V8.64a4 4 0 0 1 2-3.47L10 1.65ZM6.7 7.2l2.7 10 2.05-6.6h1.1l2.05 6.6 2.7-10-5.3 1.65-5.3-1.65Z" clipRule="evenodd"/>
  </svg>;
}

export function BiteCreditAmount({amount,label=true}:{amount:number|string;label?:boolean}) {
  return <span className="bite-credit-amount"><BiteCreditIcon/><span>{typeof amount==='number'?amount.toLocaleString('ko-KR'):amount}{label&&'크레딧'}</span></span>;
}

/** Keep approved copy intact while giving every credit amount the same identity. */
export function BiteCreditText({children}:{children:string}) {
  return <>{children.split(/(\d[\d,]*\s*크레딧)/g).map((part,index)=>/^\d[\d,]*\s*크레딧$/.test(part)?<BiteCreditAmount key={index} amount={part.replace(/\s*크레딧$/,'')}/>:part)}</>;
}
